import React, { FC } from 'react';
import { Divider, SelectProps } from 'antd';
import { Option } from 'antd/es/mentions';
import { useTranslation } from 'react-i18next';
import { useAgents } from '~/controllers/agent';
import { useIsTablet } from '~/hooks/useScreenSizes';
import Select from './Select';

interface Props extends SelectProps<string> {
  hasSimpleView?: boolean;
}

const AssigneeSelect: FC<Props> = (props) => {
  const { hasSimpleView, ...rest } = props;
  const agents = useAgents();
  const [t] = useTranslation('agent');
  const optionsForAgent =
    agents.data
      ?.filter(({ currentUser }) => currentUser)
      .map(({ id }) => ({
        label: t('Current User'),
        value: id,
        key: id,
      })) ?? [];

  const unassignedOption = {
    label: t('Unassigned'),
    value: UNASSIGNED_FILTER_VALUE,
    key: UNASSIGNED_FILTER_VALUE,
  };
  const optionsForTeamLead =
    agents.data
      ?.filter(({ currentUser }) => !currentUser)
      ?.map(({ id, fullName }) => ({
        label: fullName,
        value: id,
        key: id,
      })) ?? [];

  const options =
    agents.data?.map(({ id, fullName }) => ({
      label: fullName,
      value: id,
      key: id,
    })) ?? [];

  const isTablet = useIsTablet();
  return (
    <Select loading={agents.isLoading} disabled={agents.isLoading} showSearch={!isTablet} {...rest}>
      {hasSimpleView ? (
        options.map((option) => (
          <Option {...option} key={option.key}>
            {option.label}
          </Option>
        ))
      ) : (
        <>
          {optionsForAgent.map((option) => (
            <Option {...option} key={option.key}>
              {option.label}
            </Option>
          ))}
          <Option {...unassignedOption}>{unassignedOption.label}</Option>
          {optionsForTeamLead.length !== 0 ? (
            <Option disabled style={{ minHeight: 0 }}>
              <Divider style={{ margin: 0 }} />
            </Option>
          ) : null}
          {optionsForTeamLead.map((option) => (
            <Option {...option} key={option.key}>
              {option.label}
            </Option>
          ))}
        </>
      )}
    </Select>
  );
};

const UNASSIGNED_FILTER_VALUE = 'UNASSIGNED';

export default AssigneeSelect;
